exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\n  height: 1px;\n  /* Set the hr color */\n  color: rgb(204, 204, 204); /* old IE */ /* Modern Browsers */\n}[dir] hr {\n  margin-top: 2px;\n  border: none;\n  background-color: rgb(204, 204, 204);\n}\n#popupResultsOfDETRANTests .vs-popup {\n  width: 60% !important;\n}\n.con-vs-popup .vs-popup {\n  width: 100%;\n}\n.noOverflow .vs-popup--content {\n  overflow: hidden;\n}\n.con-vs-checkbox {\n  /* position: relative; */\n  display: -webkit-box !important;\n}\n", ""]);

// exports
